import FinePrint from 'src/design/components/bodyText/FinePrint';

const HelpDisclaimerText = ({ children, className }) =>
  <FinePrint className={className}>{children}</FinePrint>;

export default HelpDisclaimerText;
